import React from "react";
import T from "prop-types";

export default function SummaryStat({ label, value }) {
  return (
    <div>
      <span style={{ fontStyle: "normal", color: "rgba(255, 255, 255, 0.8)" }}>
        {label}:
      </span>{" "}
      <span style={{ fontWeight: "bold" }}>{value}</span>
    </div>
  );
}

SummaryStat.propTypes = {
  label: T.string.isRequired,
  value: T.oneOfType([T.string, T.number])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/SummaryStat.jsx